/** Session flag set before post-registration sign-in so PendingAccess (or app shell) can show the success message after AuthComponent unmounts. */
const KEY = 'barsales_registration_success'

export function markRegistrationSuccessForNextView(): void {
  sessionStorage.setItem(KEY, '1')
}

/** Returns true once after registration success; clears the flag. */
export function consumeRegistrationSuccessNotice(): boolean {
  if (sessionStorage.getItem(KEY) === '1') {
    sessionStorage.removeItem(KEY)
    return true
  }
  return false
}

export function clearRegistrationSuccessNotice(): void {
  sessionStorage.removeItem(KEY)
}
